import { ExtensionDefinition, PageBlueprint } from '@backstage/frontend-plugin-api';
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';

export const EntitySimCorpSystemCard: ExtensionDefinition = EntityCardBlueprint.make({
    name: 'EntitySystemRolesCard',
    params: {
        filter: entity => entity.kind === 'User',
        loader: async () => import('./components/EntitySystemRolesCard').then(m => <m.EntitySystemRolesCard />),
    }
});

export const EntitySimCorpAboutCard: ExtensionDefinition = EntityCardBlueprint.make({
    name: 'EntitySimCorpAboutCard',
    params: {
      filter: entity => entity.kind !== 'User' && entity.kind !== 'Group',
      loader: async () => import('./components/SimCorpAboutCard').then(m => <m.SimCorpAboutCard />),
    }
});

export const EntityHasAiResourcesCard: ExtensionDefinition = EntityCardBlueprint.make({
    name: 'EntityHasAiResourcesCard',
    params: {
        filter: { kind: 'system' },
        loader: async () => import('./components/EntityHasAiResourcesCard').then(m => <m.EntityHasAiResourcesCard />),
    }
});

export const EntitySkillCard: ExtensionDefinition = EntityCardBlueprint.make({
    name: 'EntitySkillCard',
    params: {
        filter: { kind: 'airesource', 'spec.type': 'skill' },
        loader: async () => import('./components/EntitySkillCard').then(m => <m.EntitySkillCard />),
    }
});

export const EntityMcpServerCard: ExtensionDefinition = EntityCardBlueprint.make({
    name: 'EntityMcpServerCard',
    params: {
        filter: { kind: 'api', 'spec.type': 'mcp-server' },
        loader: async () => import('./components/EntityMcpServerCard').then(m => <m.EntityMcpServerCard />),
    }
});

export const SystemDataClassificationPage = PageBlueprint.make({
    params: {
        path: '/data-classification',
        loader: () => import('./components/SystemDataClassificationPage').then(m => <m.SystemDataClassificationPage />),
    },
});

export const GroupRiskCalculatorPage = PageBlueprint.make({
    name: 'GroupRiskCalculatorPage',
    params: {
        path: '/group-risk-calculator',
        loader: () => import('./components/GroupRiskCalculator').then(m => <m.GroupRiskCalculator />),
    },
});

export const ToolsPage = PageBlueprint.make({
    name: 'ToolsPage',
    params: {
        path: '/tools',
        loader: () => import('./components/ToolsPage').then(m => <m.ToolsPage />),
    },
});
